module.exports = __webpack_public_path__ + "img/title-bg.a7c4e761.png";